import React from "react";
import { Flex } from "@mantine/core";

export default function ActionBar({
  children,
  color = "gray",
  containerProps = {},
}) {
  return (
    <Flex
      gap="xs"
      align="center"
      style={{
        background: `var(--mantine-color-${color}-1)`,
        border: `1px solid var(--mantine-color-${color}-3)`,
        padding: ".75em",
        borderRadius: "0.5em",
      }}
      {...containerProps}
    >
      {children}
    </Flex>
  );
}
